<template>
  <span>
    <span class="mr-2" v-if="site.stname">{{site.stname}}</span>
    <a @click="navigatorRouter(selfLevel, 1)">{{items.memname}}</a>
      <template v-if="LevelList.length > 0 && items">
        <span v-for="it in  LevelList" :key="it.mid">
          - {{it.name}}
          <a @click="navigatorRouter(it.hie, it.mid)">[{{it.val}}]</a> 
        </span>
      </template>
       <span v-if="items && items.upname && items.memname != items.upname">
          -
          {{items.mlevel == '7' ? '会员' : LevelName[items.mlevel].name}}
          [{{items.upname}}]
        </span>
      <span> - {{query.stdate}}-{{query.endate}}</span>
    </span>
  </span>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name:'BreadcrumbLevel',
  data () {
    return {
      items: '',
      sitelist: []
    }
  },
  computed: {
    ...mapGetters(['getmember']),
    site () {
      if(this.sitelist.length == 0 || String(this.query.stidlist).split(",").length > 1 ) return {stid:'',stname:''}
      return this.sitelist.filter(it => it.stid == this.query.stidlist || it.stid == this.query.stid)[0]
    },
    query () {
      return this.$route.query
    },
    selfLevel () {
      let resutl
      if ([1, 9].some(it => it == this.getmember.mlevel)) {
        resutl = 1
      } else {
        resutl = this.getmember.mlevel
      }
      return resutl
    },
    LevelList () {
      if (!Object.values(this.items).length) return []
      let array = Object.values(this.LevelName).filter(it => it.val != null)
      return array
    },
    LevelName () {
      return {
        '2': { mid: this.items.l2id, hie: 2, name: '分公司', val: this.items.l2name },
        '3': { mid: this.items.l3id, hie: 3, name: '大股东', val: this.items.l3name },
        '4': { mid: this.items.l4id, hie: 4, name: '股东', val: this.items.l4name },
        '5': { mid: this.items.l5id, hie: 5, name: '总代', val: this.items.l5name },
        '6': { mid: this.items.l6id, hie: 6, name: '代理', val: this.items.l6name }
      }
    }
  },
  watch: {
    '$route': 'getList'
  },
  created() {
    if(String(this.query.stidlist).split(",").length > 1) return
    this.getList()
  },
  methods: {
    async getList () {
      try {
        this.sitelist = await this.$axios.generalLedger.getsitelist()
        const res = await this.$axios.generalLedger.linkrepuplv({...this.query,stid: this.site.stid})
        if ('status' in res && res.status === 0) return
        this.items = res[0].data[0]
      } catch (error) {
        console.error(error)
      }
    },
    async navigatorRouter (hie, mid) {
      const { stdate, endate, iscal } = this.query
      switch (hie) {
        case 1:
          this.$router.push({ 
            name: 'general-ledger-reporta1', 
            query: { stdate: stdate, endate: endate, gmclist: this.query.gamelist, iscal: iscal,stidlist: this.site.stid,mid:1,gamelist: this.query.gamelist },
            params: this.$route.params }) 
          break;
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
          this.$router.push({ 
            name: `general-ledger-reporta${hie}`, 
            query: { stdate: stdate, endate: endate, gmclist: this.query.gamelist, iscal: iscal, mid: mid,stid: this.site.stid,gamelist: this.query.gamelist },
            params: this.$route.params })
          break;
        default:
          break;
      }
    }
  }
}
</script>